import React from 'react'
import PropTypes from 'prop-types'

import { ButtonCaution, ButtonSecondary } from '../generic/buttons'
import Modal, { RightFooter } from '../generic/Modal'
import { getObserverNameToUse } from '../../library/observerHelpers'
import { observerPropType } from '../../App/mermaidData/mermaidDataProptypes'
import { useTranslation, Trans } from 'react-i18next'

const RemoveObserverModal = ({ isOpen, onDismiss, observer = undefined, onSubmit }) => {
  const { t } = useTranslation()
  const observerNameToUse = observer ? getObserverNameToUse(observer) : ''

  const footerContent = (
    <RightFooter>
      <ButtonSecondary type="button" onClick={onDismiss}>
        {t('buttons.cancel')}
      </ButtonSecondary>
      <ButtonCaution type="button" onClick={onSubmit} data-testid="remove-observer-confirm-button">
        {t('remove_user')}
      </ButtonCaution>
    </RightFooter>
  )

  return (
    <Modal
      isOpen={isOpen}
      onDismiss={onDismiss}
      title={t('remove_observer_from_record')}
      mainContent={
        <Trans i18nKey="remove_user_confirmation" values={{ userName: observerNameToUse }} />
      }
      footerContent={footerContent}
      testid="remove-observer-modal"
    />
  )
}

RemoveObserverModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  observer: observerPropType,
}

export default RemoveObserverModal
